import ExcelJS from 'exceljs';
import { capitalizeFirstLetterWord } from '../../helpers/commonHelpers';
import { convertFromStringToDate, getMonthDayYear } from '../../helpers/dateHelpers';

export const getWorkBook = (sdoDetails, profileContext) => {
    const workbook = new ExcelJS.Workbook();
    if (sdoDetails !== undefined || sdoDetails !== null) {
        const exportDateString = convertFromStringToDate(sdoDetails?.exportDate);

        const quarterArray = sdoDetails?.sdoRequests && Object.keys(sdoDetails?.sdoRequests);
        let allQuarterLength = 0;
        
        quarterArray.forEach(element => {
            let keyLength = Object.keys(sdoDetails?.sdoRequests[element]).length
            allQuarterLength = allQuarterLength + keyLength;
        });

        workbook.addWorksheet(`${'SDO'} ${sdoDetails?.year} | ${"Summary"}`)
        workbook.addWorksheet("All requests")
        quarterArray.map(item => workbook.addWorksheet(item))

        //summary starts//
        const sheet = workbook.getWorksheet(`${'SDO'} ${sdoDetails?.year} | ${"Summary"}`)

        sheet.getRow(1).fill = {
            type: 'pattern',
            pattern: 'solid',
        }

        sheet.getRow(3).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'fff3cc' }
        }
        sheet.getRow(2).height = 18;
        sheet.getRow(2).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'fff3cc' }
        }

        let sdoYear = sdoDetails?.year
        let sdoStatus = sdoDetails?.cycleStatus
        let sdoUsage = "SDO Usage";
        let sdoReport = "Report";
        let sdoCycle = "Cycle"
        let exportedBy = "by"
        let date = new Date(sdoDetails?.exportTimestamp); 
        let easterTime=date.toLocaleString('en-GB', {timeZone: 'Canada/Eastern',}).split(",");
        let reportExportedTime=easterTime[1];
        sheet.getCell('A1').value = `${sdoUsage} - ${sdoYear} ${sdoReport} (${sdoCycle} ${sdoStatus})`;
        let lastQuarterMonth = quarterArray[quarterArray.length - 1];
        let firstQuarterMonth = quarterArray[0];

        let SdoLastQuarterMonth;
        if (lastQuarterMonth === 'Q1') {
            SdoLastQuarterMonth = "March"
        } else if (lastQuarterMonth === 'Q2') {
            SdoLastQuarterMonth = "June"
        } else if (lastQuarterMonth === 'Q3') {
            SdoLastQuarterMonth = "September"
        } else {
            SdoLastQuarterMonth = "December"
        }

        let SdoFirstQuarterMonth;
        if (firstQuarterMonth === 'Q1') {
            SdoFirstQuarterMonth = "January"
        } else if (firstQuarterMonth === 'Q2') {
            SdoFirstQuarterMonth = "April"
        } else if (firstQuarterMonth === 'Q3') {
            SdoFirstQuarterMonth = "July"
        } else {
            SdoFirstQuarterMonth = "October"
        }

        sheet.getCell('A3').value = ` ${SdoFirstQuarterMonth} ${sdoYear} -  ${SdoLastQuarterMonth} ${sdoYear}`;
        sheet.getRow(1).font = { size: 30, bold: true, color: { argb: "FFFFFF" } }
        sheet.getRow(2).font = { name: 'Arial Black', color: { argb: '000000' } }
        sheet.getRow(1).height = 40;
        sheet.getCell('A4').value = 'Total Requests';
        sheet.getCell('B4').value = sdoDetails?.sdoYearlySummary?.totalRequest;
        sheet.columns = [
            { key: 'Total Request', width: 52 },
        ]

        sheet.getCell('A5').value = 'Total Approved';
        sheet.getCell('B5').value = sdoDetails?.sdoYearlySummary?.totalApproved;

        sheet.getCell('A6').value = 'Total Declined';
        sheet.getCell('B6').value = sdoDetails?.sdoYearlySummary?.totalDeclined;

        sheet.getCell('A7').value = "SDO's Unused";
        sheet.getCell('B7').value = sdoDetails?.sdoYearlySummary?.totalUnused;


        sheet.getCell('A8').value = 'Revoked';
        sheet.getCell('B8').value = sdoDetails?.sdoYearlySummary?.totalRevoked;

        sheet.getCell('A9').value = 'Total # of SDO Requests';
        sheet.getCell('B9').value = sdoDetails?.sdoYearlySummary?.applicableSDORequests;

        sheet.getRow(3).font = { bold: true, size: 16 }
        sheet.getRow(4).font = { bold: true, color: { argb: "7030A0" }, size: 16 }
        sheet.getRow(5).font = { bold: true, color: { argb: "375623" }, size: 16 }
        sheet.getRow(6).font = { bold: true, color: { argb: "C00000" }, size: 16 }
        sheet.getRow(7).font = { bold: true, color: { argb: "305496" }, size: 16 }
        sheet.getRow(8).font = { bold: true, color: { argb: "757171" }, size: 16 }
        sheet.getRow(9).font = { bold: true, size: 16 }

        if (sdoDetails !== undefined && sdoDetails !== null) {
            let count = 0;
            quarterArray.forEach((quarter, index, quarterArray) => {

                let initialCellCount = 13 + count;
                sheet.getCell('A' + initialCellCount).value = `${quarter} | ${sdoDetails?.quarterDates[quarter][0]} - ${sdoDetails?.quarterDates[quarter][2]}`;
                sheet.getRow(initialCellCount).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'fff3cc' }
                }
                sheet.getCell('A' + initialCellCount).font = { bold: true, size: 16 };
                initialCellCount++;

                sheet.getCell('A' + initialCellCount).value = 'Total Requests';
                sheet.getCell('A' + initialCellCount).font = { bold: true, color: { argb: "7030A0" }, size: 16 };

                sheet.getCell('B' + initialCellCount).value = sdoDetails?.sdoSummary[quarter].totalRequest;
                sheet.getCell('B' + initialCellCount).font = { bold: true, color: { argb: "7030A0" }, size: 16 };
                initialCellCount++;

                sheet.getCell('A' + initialCellCount).value = 'Total Approved';
                sheet.getCell('A' + initialCellCount).font = { bold: true, color: { argb: "375623" }, size: 16 };

                sheet.getCell('B' + initialCellCount).value = sdoDetails?.sdoSummary[quarter].totalApproved;
                sheet.getCell('B' + initialCellCount).font = { bold: true, color: { argb: "375623" }, size: 16 };
                initialCellCount++;

                sheet.getCell('A' + initialCellCount).value = 'Total Declined';
                sheet.getCell('A' + initialCellCount).font = { bold: true, color: { argb: "C00000" }, size: 16 };

                sheet.getCell('B' + initialCellCount).value = sdoDetails?.sdoSummary[quarter].totalDeclined;
                sheet.getCell('B' + initialCellCount).font = { bold: true, color: { argb: "C00000" }, size: 16 };
                initialCellCount++;

                sheet.getCell('A' + initialCellCount).value = "SDO's Unused";
                sheet.getCell('A' + initialCellCount).font = { bold: true, color: { argb: "305496" }, size: 16 };

                sheet.getCell('B' + initialCellCount).value = sdoDetails?.sdoSummary[quarter].totalUnused;
                sheet.getCell('B' + initialCellCount).font = { bold: true, color: { argb: "305496" }, size: 16 };
                initialCellCount++;

                sheet.getCell('A' + initialCellCount).value = 'Revoked';
                sheet.getCell('A' + initialCellCount).font = { bold: true, color: { argb: "757171" }, size: 16 };

                sheet.getCell('B' + initialCellCount).value = sdoDetails?.sdoSummary[quarter].totalRevoked;
                sheet.getCell('B' + initialCellCount).font = { bold: true, color: { argb: "757171" }, size: 16 };
                initialCellCount++;

                sheet.getCell('A' + initialCellCount).value = 'Total # of SDO Requests';
                sheet.getCell('A' + initialCellCount).font = { bold: true, size: 16 };

                sheet.getCell('B' + initialCellCount).value = sdoDetails?.sdoSummary[quarter].applicableSDORequests;
                sheet.getCell('B' + initialCellCount).font = { bold: true, size: 16 };
                initialCellCount = initialCellCount + 3;

                if (quarterArray.length - 1 === index) {

                    sheet.getCell('A' + initialCellCount).value = 'Report Exported';
                    sheet.getCell('A' + initialCellCount).font = { bold: true };
                    initialCellCount++;

                    sheet.getCell('A' + initialCellCount).value = `${getMonthDayYear(exportDateString)} @ ${reportExportedTime} ET`;
                    initialCellCount++;

                    sheet.getCell('A' + initialCellCount).value = `${exportedBy} ${capitalizeFirstLetterWord(profileContext.profile.results?.name)}`
                }
                count += 10;
            })
        }

        const sheetTwo = workbook.getWorksheet('All requests')
        sheetTwo.getRow(1).fill = {
            type: 'pattern',
            pattern: 'solid',
        }

        sheetTwo.getRow(1).height = 40;
        sheetTwo.getRow(1).font = { size: 30, bold: true, color: { argb: "FFFFFF" } };
        sheetTwo.getCell('A1').value = `${sdoUsage} - ${sdoYear} ${sdoReport} (${sdoCycle} ${sdoStatus})`;
        sheetTwo.getRow(3).values = ['Position', 'Requests', 'Approved', 'Declined', 'Revoked', 'Unused', '# of Pilots'];
        sheetTwo.getRow(2).height = 18;
        sheetTwo.getRow(2).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFF2CC' }
        }
        sheetTwo.getRow(3).height = 16;
        sheetTwo.getRow(3).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFF2CC' }
        }
        sheetTwo.columns = [
            { key: 'position', width: 16, style: { font: { color: { argb: "000000" }, size: 12 } } },
            { key: 'request', width: 13, style: { font: { color: { argb: "7030A0" }, size: 12 } } },
            { key: 'approved', width: 13, style: { font: { color: { argb: "548235" }, size: 12 } } },
            { key: 'declined', width: 13, style: { font: { color: { argb: "C00000" }, size: 12 } } },
            { key: 'revoked', width: 13, style: { font: { color: { argb: "757171" }, size: 12 } } },
            { key: 'unsed', width: 13, style: { font: { color: { argb: "2F75B5" }, size: 12 } } },
            { key: 'ofpilots', width: 13 },
        ]
        sheetTwo.getCell('A3').font = {
            bold: true,
            size: 16,
        };

        sheetTwo.getCell('B3').font = {
            color: { argb: '7030A0' },
            bold: true,
            size: 16,
        };
        sheetTwo.getCell('C3').font = {
            color: { argb: '548235' },
            bold: true,
            size: 16,
        };
        sheetTwo.getCell('D3').font = {
            color: { argb: 'C00000' },
            bold: true,
            size: 16,
        };
        sheetTwo.getCell('E3').font = {
            color: { argb: '757171' },
            bold: true,
            size: 16,
        };
        sheetTwo.getCell('F3').font = {
            color: { argb: '2F75B5' },
            bold: true,
            size: 16,
        };
        sheetTwo.getCell('G3').font = {
            bold: true,
            size: 16,
        };
        quarterArray?.forEach((quarter) => {
            if (sdoDetails?.sdoRequests[quarter]! == null || sdoDetails?.sdoRequests[quarter] !== undefined) {
                let key = Object.keys(sdoDetails?.sdoRequests[quarter])
                key.forEach(item=>{
                    sheetTwo.addRow({
                        position: `${sdoDetails?.sdoRequests[quarter][item].pos.base} | ${sdoDetails.sdoRequests[quarter][item].pos.equipment} | ${sdoDetails.sdoRequests[quarter][item].pos.position}`,
                        request: sdoDetails?.sdoRequests[quarter][item].requests,
                        approved: sdoDetails?.sdoRequests[quarter][item].approved,
                        declined: sdoDetails?.sdoRequests[quarter][item].declined,
                        revoked: sdoDetails?.sdoRequests[quarter][item].revoked,
                        unsed: sdoDetails?.sdoRequests[quarter][item].unused,
                        ofpilots: sdoDetails?.sdoRequests[quarter][item].numberOfPilots,
                    })
                }
            )               
         }

              
            const quarterSheet = workbook.getWorksheet(quarter)
            quarterSheet.getRow(3).values = ['Position', 'Requests', 'Approved', 'Declined', 'Revoked', 'Unused', '# of Pilots'];
            quarterSheet.columns = [
                { key: 'position', width: 16, style: { font: { color: { argb: "000000" }, size: 12 } } },
                { key: 'request', width: 13, style: { font: { color: { argb: "7030A0" }, size: 12 } } },
                { key: 'approved', width: 13, style: { font: { color: { argb: "548235" }, size: 12 } } },
                { key: 'declined', width: 13, style: { font: { color: { argb: "C00000" }, size: 12 } } },
                { key: 'revoked', width: 13, style: { font: { color: { argb: "757171" }, size: 12 } } },
                { key: 'unsed', width: 13, style: { font: { color: { argb: "2F75B5" }, size: 12 } } },
                { key: 'ofpilots', width: 13 },
            ]

            let key = Object.keys(sdoDetails?.sdoRequests[quarter])
            key.map(item =>
                quarterSheet.addRow({
                    position: `${sdoDetails?.sdoRequests[quarter][item].pos.base} | ${sdoDetails.sdoRequests[quarter][item].pos.equipment} | ${sdoDetails.sdoRequests[quarter][item].pos.position}`,
                    request: sdoDetails?.sdoRequests[quarter][item].requests,
                    approved: sdoDetails?.sdoRequests[quarter][item].approved,
                    declined: sdoDetails?.sdoRequests[quarter][item].declined,
                    revoked: sdoDetails?.sdoRequests[quarter][item].revoked,
                    unsed: sdoDetails?.sdoRequests[quarter][item].unused,
                    ofpilots: sdoDetails?.sdoRequests[quarter][item].numberOfPilots,
                }))

            quarterSheet.getRow(1).height = 40;
            quarterSheet.getRow(1).font = { size: 30, bold: true, color: { argb: "FFFFFF" } };
            quarterSheet.getRow(1).fill = {
                type: 'pattern',
                pattern: 'solid',
            }
            quarterSheet.getCell('A1').value = `SDO Usage - ${sdoYear} ${quarter} (${sdoDetails?.quarterDates[quarter][0]} - ${sdoDetails?.quarterDates[quarter][2]} ${sdoYear})`;
            quarterSheet.getRow(2).height = 18;
            quarterSheet.getRow(2).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFF2CC' }
            }
            quarterSheet.getRow(3).height = 16;
            quarterSheet.getRow(3).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFF2CC' }
            }

            quarterSheet.getCell('A3').font = {
                bold: true,
                size: 16,
            };

            quarterSheet.getCell('B3').font = {
                color: { argb: '7030A0' },
                bold: true,
                size: 16,
            };
            quarterSheet.getCell('C3').font = {
                color: { argb: '548235' },
                bold: true,
                size: 16,
            };
            quarterSheet.getCell('D3').font = {
                color: { argb: 'C00000' },
                bold: true,
                size: 16,
            };
            quarterSheet.getCell('E3').font = {
                color: { argb: '757171' },
                bold: true,
                size: 16,
            };
            quarterSheet.getCell('F3').font = {
                color: { argb: '2F75B5' },
                bold: true,
                size: 16,
            };
            quarterSheet.getCell('G3').font = {
                bold: true,
                size: 16,
            };

            let eachQuarterLength = (sdoDetails?.sdoRequests[quarter].length) + 5;
            quarterSheet.getCell('A' + eachQuarterLength).value = 'Report Exported'
            quarterSheet.getCell('A' + eachQuarterLength).font = { bold: true };
            eachQuarterLength++;
            quarterSheet.getCell('A' + eachQuarterLength).value = `${getMonthDayYear(exportDateString)} @ ${reportExportedTime} ET`;
            eachQuarterLength++;
            quarterSheet.getCell('A' + eachQuarterLength).value = `${exportedBy} ${capitalizeFirstLetterWord(profileContext.profile.results?.name)}`
        })

        let exportedByAllQuarterLength = allQuarterLength + 5;
        sheetTwo.getCell('A' + exportedByAllQuarterLength).value = 'Report Exported'
        sheetTwo.getCell('A' + exportedByAllQuarterLength).font = { bold: true };
        exportedByAllQuarterLength++;
        sheetTwo.getCell('A' + exportedByAllQuarterLength).value = `${getMonthDayYear(exportDateString)} @ ${reportExportedTime} ET`;
        exportedByAllQuarterLength++;
        sheetTwo.getCell('A' + exportedByAllQuarterLength).value = `${exportedBy} ${capitalizeFirstLetterWord(profileContext.profile.results?.name)}`
    }
    return workbook;
}

// File title: ‘SDO Usage [YYYY] - [cycle status] [export date dd-mm-yyyy]’ ie. 'SDO Usage 2023 - OPEN Nov 03, 2023'

const getFileName = (sdoUsageReportsData) => {
    if (!sdoUsageReportsData) return;
    const exportDate = convertFromStringToDate(sdoUsageReportsData?.exportDate);
    return `${'SDO Usage'} ${sdoUsageReportsData?.year} - ${(sdoUsageReportsData?.cycleStatus).toUpperCase()} ${getMonthDayYear(exportDate)}`
}

export const download = async (format, workbook, sdoUsageReportsData) => {
    const uint8Array =
        format === "xlsx"
            ? await workbook.xlsx.writeBuffer() : '';
    const blob = new Blob([uint8Array], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', url);
    a.setAttribute('download', `${getFileName(sdoUsageReportsData)}${'.'}` + format);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};

export const IPADVIEWCONSTANTS = {
    MAXWIDTH: 1180,
    MINWIDTH: 768, 
};